/* eslint-disable @typescript-eslint/no-explicit-any */
import { getTranslations } from 'next-intl/server';

export type AiServiceColor = 'blue' | 'green' | 'orange' | 'pink';
export type AiServiceSlug = 'strategy-discovery' | 'search-knowledge' | 'product-development' | 'powered-automation';

export interface AiServiceGroup {
  id: AiServiceSlug;
  slug: string;
  accentColor: AiServiceColor;
  hrSlug: string;
  metaKey: string;
}

export interface AiServicePageConfig {
  slug: string;
  accentColor: AiServiceColor;
  hrSlug: string;
  metaTitle: string;
  metaDescription: string;
  hero: {
    title: string;
    description: string;
  };
  solutionsShowcase: {
    title: string;
    description: string;
    cta: string;
    solutions: { title: string; description: string; features: string[] }[];
  };
}

export const aiServiceGroups: AiServiceGroup[] = [
  {
    id: 'strategy-discovery',
    slug: 'ai-strategy-discovery',
    accentColor: 'blue',
    hrSlug: 'ai-strategija-i-istrazivanje',
    metaKey: 'aiServicesStrategy',
  },
  {
    id: 'search-knowledge',
    slug: 'ai-search-knowledge',
    accentColor: 'pink',
    hrSlug: 'ai-pretraga-i-znanje',
    metaKey: 'aiServicesSearch',
  },
  {
    id: 'product-development',
    slug: 'ai-product-development',
    accentColor: 'green',
    hrSlug: 'ai-razvoj-proizvoda',
    metaKey: 'aiServicesProduct',
  },
  {
    id: 'powered-automation',
    slug: 'ai-powered-automation',
    accentColor: 'orange',
    hrSlug: 'ai-automatizacija-procesa',
    metaKey: 'aiServicesAutomation',
  },
];

export const aiServiceSlugs: string[] = aiServiceGroups.map(g => g.slug);

const parseSolutions = (raw: Record<string, { title: string; description: string; features: string[] }>) =>
  Object.values(raw).map(s => ({
    title: s.title,
    description: s.description,
    features: s.features,
  }));

export const AiServicesPageConfig = async (): Promise<AiServicePageConfig[]> => {
  const t = (await getTranslations('ai-services.singlePage' as any)) as any;
  const tMeta = (await getTranslations('metadata')) as any;

  return aiServiceGroups.map(group => ({
    slug: group.slug,
    accentColor: group.accentColor,
    hrSlug: group.hrSlug,
    metaTitle: tMeta(`${group.metaKey}.title`),
    metaDescription: tMeta(`${group.metaKey}.description`),
    hero: {
      title: t(`${group.id}.hero.title`),
      description: t(`${group.id}.hero.description`),
    },
    solutionsShowcase: {
      title: t(`${group.id}.solutionsShowcase.title`),
      description: t(`${group.id}.solutionsShowcase.description`),
      cta: t(`${group.id}.solutionsShowcase.cta`),
      solutions: parseSolutions(t.raw(`${group.id}.solutionsShowcase.solutions`)),
    },
  }));
};
